<template>
    <div class="app-inner" id="addAppAuth">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit"
            >
              保存
            </el-button>
            </div>
             <div class="edit-from">
                 <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
            <div class="addAppAuth-container">
                <div class="businessList-filter-list flex align-cen">
                    <div class="label">选择课程：</div>
                    <div class="public-btn-small" style="padding-left:0"  @click="openBl(0)">
                         <div class="public-btn-small-primary">选择授权课程</div>
                    </div>
                </div>
                    <div class="show-table" v-if="multipleSelection.length !=0">
                       <el-table
                    :data="multipleSelection"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%;margin-top:16px"
                    border
                    id='mytable'
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                       <el-table-column label="课程封面" align="center" prop="pic">
                        <template slot-scope="scope" >
                            <img :src="scope.row.logo ? scope.row.logo : ''" alt="" style="display: block;width:50%;margin:0 auto">
                        </template>
                       </el-table-column>
                            <el-table-column label="课程ID" align="center" prop="id">
                            </el-table-column>
                            <el-table-column label="课程名称" align="center" prop="title">
                            </el-table-column>
                            <el-table-column label="课程分类" align="center" prop="classifyName">
                            </el-table-column>
                            <el-table-column label="课时数量" align="center" prop="chapterNum">
                            </el-table-column>
                         <el-table-column label="操作" align="center"
                          fixed="right"
                         >
                                    <el-button type="text" size="small"  style="color:red" @click="openBl(0)">更换</el-button>
                            </el-table-column>
                  </el-table>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">选择使用企业：</div>
                    <div class="public-btn-small" style="padding-left:0"  @click="openBl(1)">
                         <div class="public-btn-small-primary">选择使用企业</div>
                    </div>
                </div>
                 <div class="show-table" v-if="multipleSelection1.length !=0">
                <el-table
          ref="multipleTable1"
          :data="multipleSelection1"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable1'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
          <el-table-column prop="id" label="企业id" align="center">
          </el-table-column>
          <el-table-column prop="name" label="企业名称" align="center">
          </el-table-column>
          <el-table-column prop="classifyName" label="企业类型" align="center">
          </el-table-column>
          <el-table-column label="企业电话" align="center" prop="phone">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center">
          </el-table-column>
          <el-table-column label="企业状态" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.state == 0
                  ? "试用"
                  : scope.row.state == 1
                  ? "有意向"
                  : scope.row.state == 2
                  ? "谈判"
                  : scope.row.state == 3
                  ? "合作中"
                  : "停止合作"
              }}</span>
            </template>
          </el-table-column>

           <el-table-column label="操作" align="center">
            <template slot-scope="scope">
          <el-button
                type="text"
                size="small"
                style="color:red"
                @click="openBl(1)"
                >更换</el-button >
            </template>
           </el-table-column>
        </el-table>
                 </div>
                  <div class="businessList-filter-list flex align-cen">
                    <div class="label">授权时间：</div>
                     <el-radio v-model="radio" label="1">无时间限制</el-radio>
                     <el-radio v-model="radio" label="0">指定时间</el-radio>
                </div>
                <div class="businessList-filter-list flex align-cen" v-if="radio == '0'">
                    <div class="label">选择时间：</div>
                      <el-date-picker
                        v-model="value2"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions2"
                        @change="dataSuccess"
                        >
                        </el-date-picker>
                </div>
                 <div class="businessList-filter-list flex align-cen">
                    <div class="label">最大授权账号数：</div>
                     <div class="el-select1">
                        <el-input placeholder="请输入最大授权账号数" v-model="search" clearable
                        @change="confirmTelephone"
                        > </el-input>
                    </div>
                </div>
            </div>
                    
             </div>
                     <!-- 选择课程弹框 -->
                     <el-dialog
                    title="选择授权课程"
                    :visible.sync="centerDialogVisible"
                    width="80%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible"
                    >
                      <div class="forminfo">
                        <courseTemplate :authType = '1'
                        @sendStatus="classSelect"
                        ref="appTemplate"
                        ></courseTemplate>
                    </div>
                     </el-dialog>
                     <!-- 选择产品弹框 -->
                       <el-dialog
                    title="选择使用企业"
                    :visible.sync="centerDialogVisible1"
                    width="80%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible1"
                    >
                      <div class="forminfo">
                        <bussTemplate :authType = '1'
                        @sendStatus1="bussClassSelect"
                        ref="bussTemplate"
                        ></bussTemplate>
                    </div>
                     </el-dialog>
    </div>
</template>
<script>
import courseTemplate from "@/views/Course/index.vue"; //将课程列表页面作为组件使用
import bussTemplate from "@/views/businessList/index.vue"; //将企业列表页面作为组件使用
import { courseAuthfun} from "@/api/index/index"  //新增授权
export default {
    name:'addAppAuth',
    components:{
        bussTemplate,
        courseTemplate
    },
    data() {
        return {
            loading:false,
            multipleSelection:[],
            multipleSelection1:[],
            centerDialogVisible:false,
            centerDialogVisible1:false,
            businessId:'',
            appId:'',
            radio:'',
            value2:'',
             start_time:'',
        end_time:'',
        search:'',
                  pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    created() {
        
    },
    methods: {
      confirmTelephone() {
        if (!/^[0-9]{0,10}$/.test(this.search)){
          this.$message.error('请输入符合规则的数字')
         return this.search= ''
        }
        },
        // 时间选择
        dataSuccess(){
            if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }
        },
        // 选择企业
        bussClassSelect(val){
          this.multipleSelection1 = []
          this.multipleSelection1.push(val)
          this.businessId = val.id
          this.centerDialogVisible1 = false
        },
        //  选择课程
        classSelect(val){
            this.multipleSelection = []
            this.multipleSelection.push(val)
            console.log(this.multipleSelection)
            this.appId = val.id
            this.centerDialogVisible = false
        },
        //返回
        reback(){
            this.$router.push('/courseAuth')
        },
        // 确定保存
        onSubmit(){
            if(!this.appId) return this.$message.error('请选择课程')
            if(!this.businessId) return this.$message.error('请选择使用企业')
            if(!this.radio) return this.$message.error('请选择授权时间')
            if(this.radio == '0' && !this.value2) return this.$message.error('请选择授权时间范围')
            if(!this.search) return this.$message.error('请输入最大授权账号数')
            let params = {
                businessId:this.businessId,
                courseId:this.appId,
                type:'1',
                accountNum:this.search,
                timeLimit:this.radio,
                startTime:this.start_time,
                endTime:this.end_time
               }
            this.loading = true
             courseAuthfun(params,'post')
                        .then(res => {
                          this.loading = false
                           if(res.code == 0){
                         this.$message.success('新增成功'); 
                                setTimeout(() => {
                           this.$router.push("/courseAuth")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                        })
        },
        openBl(type){
            // type == 0 表示课程弹窗； type == 1 表示企业弹窗
            type == 0 ? this.centerDialogVisible = true : this.centerDialogVisible1 = true
        },
    },
}
</script>
<style lang="scss" scoped>
.edit-from{
    margin-bottom: 44px;
    .addAppAuth-container{
        margin-top: 20px;
        .businessList-filter-list,.show-table{
            margin-bottom: 20px;
        }
        .label{
            position: relative;
        }
        .label::before{
            content: '*';
          color: #f56c6c;
            margin-right: 4px;
        }
    }
}
.forminfo{
    margin-top: -50px;
}
</style>